import { DestroyRef, effect, inject, type Signal } from '@angular/core';
import { CabinetPageLayoutService } from '@nebalkon-workspace/cabinet-client';

/** Pushes active-only list count into `CabinetClientPageComponent` title badge when embedded. */
export function bindStaffPageTitleCount(
  embeddedInCabinetPage: Signal<boolean>,
  displayCount: Signal<number | null>,
): void {
  const layout = inject(CabinetPageLayoutService, { optional: true });
  const destroyRef = inject(DestroyRef);

  effect(() => {
    if (!embeddedInCabinetPage() || !layout) {
      return;
    }
    layout.setTitleCount(displayCount());
  });

  destroyRef.onDestroy(() => {
    layout?.setTitleCount(null);
  });
}
